import clsx from "clsx";
import { OptionComponent, useSection } from "@tree-company/tree-query";
import { useEffect, useRef, useState } from "react";

export function CollapsibleRadio({ question, className, handleChange }) {
  const containerRef = useRef(null);
  const {
    htmlAttributes,
    required,
    valid,
    disabled,
    ariaDisabled,
    key,
    title,
    description,
    value,
    hint,
    errorMessages,
    options,
  } = useSection(question);
  const [collapsed, setCollapsed] = useState(false);

  const labelValue = options.find((opt) => opt.value === value)?.label;

  useEffect(() => {
    if (collapsed || containerRef.current === null) return;
    const closeOnClickOutside = (event) => {
      if (containerRef.current === null) {
        window.removeEventListener("click", closeOnClickOutside);
        return;
      }

      if (!containerRef.current.contains(event.target) && value) {
        setCollapsed(true);
        window.removeEventListener("click", closeOnClickOutside);
      }
    };

    window.addEventListener("click", closeOnClickOutside);
  }, [collapsed, value]);

  return (
    <fieldset
      className={clsx(
        "question",
        "question--radio",
        "question--radio-collapsable",
        htmlAttributes.class,
        { "question--required": required },
        { "question--invalid": !valid },
        { "question--disabled": disabled || ariaDisabled },
        { "question--collapsed": collapsed },
        className,
      )}
      name={key}
      disabled={disabled}
      aria-disabled={ariaDisabled}
      data-testid="fieldset"
      onClick={() => setCollapsed(false)}
      ref={containerRef}
    >
      <legend className="question__label">
        {title}
        {description && (
          <span className="question__description">{description}</span>
        )}
      </legend>

      {value && <output className="question__output">{labelValue}</output>}

      <div className={clsx("question__options", "question__options--radios")}>
        {options.map((opt) => (
          <OptionComponent
            baseKey={key}
            option={opt}
            className="question__option"
            type={"radio"}
            key={opt.value.toString()}
            checked={value === opt.value}
            onChange={(e) => handleChange(e, opt.value)}
          />
        ))}
      </div>
      {hint && <span className="question__hint">{hint}</span>}
      {errorMessages.length > 0 && (
        <span className="question__error">{errorMessages[0]}</span>
      )}
    </fieldset>
  );
}
